import { ButtonProps, Icon, Text } from "@ttc3k/trekker";
import { Flex, styled } from "styled-system/jsx";
import { buttonCardRecipe } from "./recipe";

type ButtonCardProps = {
  Icon?: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
  title: string;
  description: string;
  onClick: () => void;
  isSelected?: boolean;
  buttonProps?: ButtonProps;
  /** `start` left-aligns icon and copy (grid tiles); default is centered. */
  align?: "center" | "start";
};

export const ButtonCard = ({
  Icon: IconElement,
  title,
  description,
  onClick,
  isSelected,
  buttonProps,
  align = "center",
}: ButtonCardProps) => {
  const buttonCardClasses = buttonCardRecipe({ align });
  const isStart = align === "start";

  return (
    <styled.button
      onClick={onClick}
      className={buttonCardClasses}
      {...(isSelected ? { "aria-selected": isSelected } : {})}
      type="button"
      {...buttonProps}
    >
      {IconElement && (
        <Icon
          Element={IconElement}
          w="20px"
          h="20px"
          color={isStart ? "icon.light" : "icon.mid"}
        />
      )}
      <Flex flexDir="column" gap={isStart ? "50" : "100"}>
        <Text color={"text.dark"} visual={"bodySemiBold"}>
          {title}
        </Text>
        {!!description && (
          <Text
            color={isStart ? "text.light" : "text.mid"}
            visual={isStart ? "smallMedium" : "smallRegular"}
          >
            {description}
          </Text>
        )}
      </Flex>
    </styled.button>
  );
};
